import React from 'react';
import { Radio } from 'antd';
import { RadioButtonProps } from 'antd/lib/radio/radioButton';

import './index.less';

const MAIN_CLASS_NAME = 'ib-radio-button';
const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
const CIRCLE_CLASS_NAME = `${CONTENT_CLASS_NAME}__circle`;

export interface IIbRadioButtonProps extends RadioButtonProps {
  showCircle?: boolean;
}

const IbRadioButton: React.FC<IIbRadioButtonProps> = ({ className, children, showCircle = false, ...otherProps }) => {
  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);

  return (
    <Radio.Button {...otherProps} className={classes.join(' ')}>
      <div className={CONTENT_CLASS_NAME}>
        <>
          {children}
          {showCircle && <div className={CIRCLE_CLASS_NAME} />}
        </>
      </div>
    </Radio.Button>
  );
};

export default IbRadioButton;
